import { useLocation } from "react-router-dom";
import { useI18n } from "@/lib/i18n";

const routeTitles = {
    "/app": "nav.dashboard",
    "/app/analytics": "nav.analytics",
    "/app/widgets/panel": "nav.sizing-panel",
    "/app/experiences/size-chart": "nav.size-chart-modal",
    "/app/experiences/find-my-size": "nav.find-my-size-wizard",
    "/app/catalog/products": "nav.products",
    "/app/catalog/tables": "nav.tables",
    "/app/sizing/sizes": "nav.size-series",
    "/app/sizing/measurement-groups": "nav.measurement-groups",
    "/app/sizing/fit-info": "nav.fit-info",
    "/app/sizing/models": "nav.models",
    "/app/sizing/images": "nav.images",
    "/app/site": null,
    "/app/team": null,
    "/app/settings": "nav.settings",
    "/app/integration": "nav.integration",
};

const staticTitles = {
    "/app/site": "Mağaza & Script",
    "/app/team": "Ekip",
};

export default function Topbar() {
    const { t } = useI18n();
    const loc = useLocation();

    const matchKey = Object.keys(routeTitles).find((k) => loc.pathname === k) ||
        Object.keys(routeTitles).sort((a,b) => b.length - a.length).find((k) => loc.pathname.startsWith(k));
    const staticTitle = matchKey && staticTitles[matchKey];
    const titleKey = matchKey ? routeTitles[matchKey] : "nav.dashboard";

    return (
        <header
            className="sticky top-0 z-30 h-16 border-b border-border glass"
            data-testid="app-topbar"
        >
            <div className="h-full flex items-stretch">
                <div className="flex-1 flex items-center px-5 md:px-7 min-w-0">
                    <span className="font-display text-[15px] font-semibold tracking-tight truncate" data-testid="topbar-title">
                        {staticTitle || t(titleKey)}
                    </span>
                </div>
            </div>
        </header>
    );
}
